export default __webpack_public_path__ + "static/media/distanstolkning2.37651bc0.png";